import React from 'react';
import CustomizationItem from './CustomizationItem';

class DetailedView extends React.PureComponent {
  render() {
    return (
      <div className="detailedViewCustomisations">
        {this.props.customizations.map((customizationGroup) => {
          if (customizationGroup.customizations.length === 0) {
            for (let x = 0; x < customizationGroup.quantity; x++) {
              customizationGroup.customizations.push({ x });
            }
          }
          return (
            <div className="detailedViewCustomisationSizeItem" key={customizationGroup.id}>
            {customizationGroup.customizations.map((oneCustomization, index) => {
              const id = Math.random + index;
              return (
                <CustomizationItem
                  key={id}
                  customization={oneCustomization}
                  sizeName={customizationGroup.name}
                  currency={this.props.currency}
                  image={this.props.image}
                  price={this.props.price}
                  productName={this.props.name}
                  productType={this.props.productType}
                  unitCustomizationExcludingVat={this.props.unitCustomizationExcludingVat}
                  unitCustomizationPrice={this.props.unitCustomizationPrice}
                  unitCustomizationVat={this.props.unitCustomizationVat}
                  unitDiscount={this.props.unitDiscount}
                  unitNetPrice={this.props.unitNetPrice}
                  unitPrice={this.props.unitPrice}
                  totalQuantity={this.props.totalQuantity}
                />);
               })}
            </div>
          );
        })}
      </div>
    );
  }
}

export default DetailedView;
